import React, {  } from 'react';
import styles from '../Wyszukiwarka.module.css';
import { useZamowienia } from 'hooks/useZamowienia';


  export default function Rok({rok, setRok} ){
          const { globalSearch } = useZamowienia();
    
    
        const handleSubmit = (event) => {
        event.preventDefault(); // Blokuje przeładowanie strony po wciśnięciu Enter
        globalSearch();
      };
  return(
      <form onSubmit={handleSubmit} className={styles.colData}>

      <label className={styles.labelData}> Rok </label>
      <input className={styles.inputData} style={{width:"60px"}} type="text"
            value={rok}
            onChange={(event) => {
              const re = /^[0-9]+$/;
              if (event.target.value === '' || re.test(event.target.value)) {
              setRok(event.target.value);
              }
            }}></input>
    </form>
  );
}